import { Extension } from '@tiptap/core';

const Config = Extension.create({
	name: 'config',

	addStorage() {
		return {
			toolbar: {},
			editor: {},
		};
	},

	addOptions() {
		return {
			toolbar: {},
			editor: {},
		};
	},

	onCreate() {
		this.storage.toolbar = this.options.toolbar;
		this.storage.editor = this.options.editor;
	},
});

export default Config;
